<template>
<div
  @click="toggleDetails(stepDetail)"
  class="bottom-fix bottom-summary">
  <el-row
    :gutter="10">
    <el-col
      :span="14">
      <div
        class="summary-arrow">
        <i
          class="el-icon-arrow-up">
        </i>
      </div>
      <div
        class="summary-code">
        <span v-if="mediaquery > 1">
          {{ $t('ibe.objectcode') }}:
        </span>
        <span>
          <b>{{ object.ibeData.code }}</b>
        </span>
      </div>
    </el-col>
    <el-col
      :span="10">
      <total-price
        style="text-align: center;">
      </total-price>
    </el-col>
  </el-row>
  <el-row>
    <div
      style="font-size: 18px;padding-right:5px;">
      <b>{{ object.text.name }}</b>
    </div>
  </el-row>
  <el-row
    :gutter="10">
    <el-col
      :xs="9" :sm="7" :md="6" :lg="0" :xl="0">
      <transition
        name="el-zoom-in-center"
        mode="out-in">
        <img
          :src="imageUrl"
          :key="imageUrl"
          class="image"/>
      </transition>
    </el-col>
    <el-col
      :xs="15" :sm="17" :md="18" :lg="0" :xl="0"
      class="summary-icons">
      <list-icons></list-icons>
    </el-col>
  </el-row>
  <template v-if="showFlightDetails">
    <hr style="margin: 5px 10px 5px 0px"/>
      <booking-flight-details
        :xs="24"
        :sm="24"
        :md="12"
        :lg="0"
        :xl="0"
        fontClass="very-small-font">
      </booking-flight-details>
    <hr style="margin: 5px 10px 5px 0px"/>
  </template>
  <el-row
    :gutter="10">
    <el-col
      :xs="23" :sm="16" :md="18" :lg="0" :xl="0">
      <list-services></list-services>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListIcons from './modules/ListIcons'
import ListServices from './modules/ListServices'
import TotalPrice from './modules/TotalPrice'
import { imageMixin } from '../utils/mixins'
import FlightDetails from './modules/FlightDetails'

export default {
  name: 'BookingSummary',
  mixins: [imageMixin],
  data () {
    return {
      stepDetail: 0,
      breakPointXS: 380,
      breakPointSM: 580
    }
  },
  created () {
    this.stepDetail = this.availableWidth > this.breakPointSM ? 3 : this.availableWidth < this.breakPointXS ? 1 : 2
  },
  mounted () {
    this.toggleDetails(this.stepDetail)
  },
  updated () {
    let elem = document.querySelector('.bottom-summary')
    if (elem) {
      this.updateIconPosition(elem)
      this.adjustBodyPadding(elem)
    }
  },
  computed: {
    ...mapGetters('booking', [
      'object',
      'appControl',
      'availableWidth',
      'showBookActionLoader',
      'mediaquery',
      'operatorInfo',
      'arrivalTransport',
      'returnTransport'
    ]),
    showFlightDetails () {
      let showArrival = false
      let showReturn = false
      showArrival = Object.keys(this.arrivalTransport).length && this.arrivalTransport.ibeData.type === 'FLIGHT'
      if (showArrival) {
        showArrival = this.arrivalTransport.segments.length > 0
      }
      showReturn = Object.keys(this.returnTransport).length && this.returnTransport.ibeData.type === 'FLIGHT'
      if (showReturn) {
        showReturn = this.returnTransport.segments.length > 0
      }
      return showArrival || showReturn
    }
  },
  methods: {
    updateIconPosition (elem) {
      let icon = document.querySelector('.bottom-right-icon')
      if (icon) {
        setTimeout(function () {
          icon.style.bottom = window.getComputedStyle(elem).getPropertyValue('height')
        }, 1000)
      }
    },
    updateInfoIconPosition (elem) {
      let infoIcon = document.querySelector('.bottom-right-info-icon')
      if (infoIcon && this.operatorInfo.length) {
        setTimeout(function () {
          infoIcon.style.bottom = window.getComputedStyle(elem).getPropertyValue('height')
        }, 1100)
      }
    },
    adjustBodyPadding (elem) {
      if (!this.appControl.hasFooter) {
        setTimeout(function () {
          let height = window.getComputedStyle(elem).getPropertyValue('height')
          height = parseInt(height.substr(0, height.length - 2)) + 60
          document.querySelector('body').style.paddingBottom = height + 'px'
        }, 1000)
      }
    },
    toggleDetails (step) {
      this.stepDetail = step + 1
      let elem = document.querySelector('.bottom-summary')
      switch (step) {
        case 1:
          elem.classList.add('min-details')
          break
        case 2:
          elem.classList.remove('min-details')
          elem.classList.add('mid-details')
          break
        case 3:
          elem.classList.remove('mid-details')
          elem.classList.add('full-details')
          break
        default:
          this.stepDetail = 2
          elem.classList.add('min-details')
          elem.classList.remove('mid-details')
          elem.classList.remove('full-details')
      }
      this.updateIconPosition(elem)
      this.adjustBodyPadding(elem)
      if (this.operatorInfo.length) {
        this.updateInfoIconPosition(elem)
      }
    }
  },
  components: {
    listIcons: ListIcons,
    listServices: ListServices,
    totalPrice: TotalPrice,
    bookingFlightDetails: FlightDetails
  },
  watch: {
    showBookActionLoader () {
      let elem = document.querySelector('.bottom-summary')
      this.updateIconPosition(elem)
      this.updateInfoIconPosition(elem)
    }
  }
}
</script>
